import React, { useMemo } from 'react';
import { FRONT_MUSCLES, FRONT_VIEWBOX, BACK_MUSCLES, BACK_VIEWBOX } from '../lib/musclePathData';

const INACTIVE_COLOR = '#525252';

function getHeatColor(sets) {
  if (!sets || sets <= 0) return INACTIVE_COLOR;
  if (sets <= 2) return '#92600a';
  if (sets <= 4) return '#d4a012';
  if (sets <= 6) return '#ea6c08';
  if (sets <= 9) return '#f95d00';
  return '#dc2626';
}

// Map targetMuscle names → FRONT_MUSCLES slugs
// targetMuscles uses names like 'chest', 'pectorals', 'triceps', 'quads', etc.
// FRONT_MUSCLES uses slugs like 'chest', 'biceps', 'quadriceps', etc.
const SLUG_ALIASES = {
  pectorals: 'chest',
  quads: 'quadriceps',
  delts: 'deltoids',
  shoulders: 'deltoids',
  glutes: 'gluteal',
  hamstrings: 'hamstring',
  'upper back': 'upperBack',
  'lower back': 'lowerBack',
  lats: 'upperBack',
  traps: 'trapezius',
  forearms: 'forearm',
};

export default function MiniMuscleMap({ workoutData, completedSets }) {
  const setsByMuscle = useMemo(() => {
    const counts = {};
    workoutData.forEach((ex, exIdx) => {
      const muscles = ex.targetMuscles || [];
      const completedCount = ex.sets.filter((_, sIdx) => completedSets[`${exIdx}-${sIdx}`]).length;
      if (completedCount > 0) {
        muscles.forEach(m => {
          const key = (m || '').toLowerCase();
          counts[key] = (counts[key] || 0) + completedCount;
        });
      }
    });
    return counts;
  }, [workoutData, completedSets]);

  const renderMuscles = (muscles, viewBox, prefix) =>
    muscles.map(muscle => {
      const slug = muscle.slug;
      const sets = setsByMuscle[slug]
        || setsByMuscle[muscle.statKey]
        || setsByMuscle[SLUG_ALIASES[slug]]
        || 0;
      const color = getHeatColor(sets);
      return muscle.paths.map((d, i) => (
        <path
          key={`${prefix}-${slug}-${i}`}
          d={d}
          fill={color}
          stroke="none"
          style={sets > 0 ? { filter: `drop-shadow(0 0 2px ${color})` } : undefined}
        />
      ));
    });

  return (
    <div className="flex items-center gap-0" style={{ flexShrink: 0 }}>
      <svg viewBox={FRONT_VIEWBOX} width="28" height="50" aria-hidden="true">
        {renderMuscles(FRONT_MUSCLES, FRONT_VIEWBOX, 'f')}
      </svg>
      <svg viewBox={BACK_VIEWBOX} width="28" height="50" aria-hidden="true">
        {renderMuscles(BACK_MUSCLES, BACK_VIEWBOX, 'b')}
      </svg>
    </div>
  );
}
